module.exports = __webpack_public_path__ + "static/img/7.157d8e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/7.png
// module id = UunA
// module chunks = 0